<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-compare-metrics-chart">
    <table style="width: 100%; text-align: center; border-spacing: 0px;" border="0">
    <tr>
      <td width="15%"></td>
      <td colspan="2" align="center">
        <div class="title" v-if="dataA">{{chartTitle}}</div>
      </td>
      <td width="15%">
        <div class="wy-chart-grouping" v-if="this.$refs.chartA">
          <el-select
            v-model="selectedDateRange"
            collapse-tags
            size="mini"
            style="margin-left: 5px;"
            popper-class="line-chart-dropdown"
            @change="changeDateRange"
            placeholder="Select range">
            <el-option
              v-for="(item) in $refs.chartA.wyChart.dateRangeTypes"
              :disabled="item.disabled"
              :key="item.type"
              :label="item.label"
              :value="item.type">
            </el-option>
          </el-select>
        </div>
      </td>
    </tr>
    <tr>
      <td width="15%"><br></td>
      <td width="35%">
        <div class="chartTitle" style="margin-top: 5px; padding-left: 25px;">Comparison Period A</div>
      </td>
      <td width="35%">
        <div class="chartTitle" style="margin-top: 5px; padding-left: 25px;">Comparison Period B</div>
      </td>
      <td width="15%"><br></td>
    </tr>
    <tr>
      <td v-bind:class="{'td-comparison-a': true, 'single': !isMultiple}">
        <div class="chartDate">{{parent.dateRangeDisplayA}}</div>
         <div v-if="!chartDataA || !chartDataA.data" class="chartTraceLabel">
          <div class="chartTraceRow"><span class="chartTracePercent">N/A</span></div>
        </div>
        <div v-else-if="isMultiple" class="chartTraceLabel">
          <div class="chartTraceRow" v-for="(item, index) in chartInfoList('A')" :key="index">{{item.label}}: <span class="chartTracePercent">{{item.displayValue}}</span></div>
        </div>
        <div v-else class="chartTraceLabel">
          <span class="chartTracePercent single-item-left" v-for="(item, index) in chartInfoList('A')" :key="index">{{item.displayValue}}</span>
        </div>
      </td>
      <td style="border-right: 0px solid #aaa; padding: 0px;">
        <div v-if="chartDataA && chartDataA.data">
          <wy-analytics-compare-metrics-chart-line ref="chartA" :chartData="chartDataA" :parent="module" />
        </div>
        <div v-else>          
          <div class="no-chart-data-icon"></div>
          <div class="no-chart-data">No data to compare</div>
        </div>
      </td>
      <td style="border-left: 0px solid #aaa; padding: 0px;">
        <div v-if="chartDataB && chartDataB.data">
          <wy-analytics-compare-metrics-chart-line ref="chartB" :chartData="chartDataB" :parent="module" />
        </div>
        <div v-else>          
          <div class="no-chart-data-icon"></div>
          <div class="no-chart-data">No data to compare</div>
        </div>
      </td>
      <td v-bind:class="{'td-comparison-b': true, 'single': !isMultiple}">
        <div class="chartDate">{{parent.dateRangeDisplayB}}</div>
        <div v-if="!chartDataB || !chartDataB.data" class="chartTraceLabel">
          <div class="chartTraceRow"><span class="chartTracePercent">N/A</span></div>
        </div>
        <div v-else-if="isMultiple" class="chartTraceLabel">
          <div class="chartTraceRow" v-for="(item, index) in chartInfoList('B')" :key="index">&nbsp; <span class="chartTracePercent">{{item.displayValue}}</span></div>
        </div>
        <div v-else class="chartTraceLabel">
          <span class="chartTracePercent single-item-right" v-for="(item, index) in chartInfoList('B')" :key="index">{{item.displayValue}}</span>
        </div>
      </td>
    </tr>
    </table>
    
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import WyUtils from '../../library/wy-utils.js';
import WyAnalyticsCompareMetricsChartLine from './wy-analytics-compare-metrics-chart-line';

export default Vue.extend({
  name: 'wy-analytics-compare-metrics-chart',
  components: {
    'wy-analytics-compare-metrics-chart-line': WyAnalyticsCompareMetricsChartLine,
  },
  props: ['parent', 'dataA', 'dataB'],

  data() {
    return {
      module: this,
      selectedDateRange: 'day',
      chartDataA: {},
      chartDataB: {},
      chartViewType: 'week'
    }
  },

  computed: {
    isMultiple() {
      return (this.chartDataA && this.chartDataA.columns && this.chartDataA.columns.length > 1 && this.chartDataB && this.chartDataB.columns.length > 1);
    },

    chartTitle() {
      return this.chartDataA.title
    }
  },

  methods: {
    formatDate(date) {
      return moment(date).format("MMM DD, YYYY");
    },

    changeDateRange(val) {
      this.chartViewType = val;

      setTimeout(() => {
        let aData = this.$refs.chartA ? this.$refs.chartA.initData(val) : null
        let bData = this.$refs.chartB ? this.$refs.chartB.initData(aData.dateRange) : null

        let options = {};
        if(aData) {
          let minValueA = aData.minValue;
          let minValueB = bData ? bData.minValue : null;
          let maxValueA = aData.maxValue;
          let maxValueB = bData ? bData.maxValue: null;
          let minValue = (minValueA <= minValueB ? minValueA : minValueB);
          let maxValue = (maxValueA >= maxValueB ? maxValueA : maxValueB);

          this.selectedDateRange = aData.dateRange;

          options = {
            minYValue: minValue,
            maxYValue: maxValue
          }
          this.$refs.chartA.buildChart(options);
        }
        else {  //if aData is null, only show bData. need to verify this case should show b cahrt or not
          if(bData) {
            let minValue = bData.minValue;
            let maxValue = bData.maxValue;
            options = {
              minYValue: minValue,
              maxYValue: maxValue
            }
            this.$refs.chartB.buildChart(options);
          }
        }
        
        if(this.$refs.chartB) this.$refs.chartB.buildChart(options);
      }, 300)
    },

    chartInfoList(type) {
      let list = [];
      let chartData = this[`chartData${type}`]
      if(chartData && chartData.data && chartData.data.info && chartData.columns) {
        chartData.columns.forEach(column => {
          let chartInfo = chartData.data.info[column];
          if(chartInfo) {
            let value = chartInfo.value;
            if(chartData.suffix == 'm') {
              value = (value == 0) ? '0s' : WyUtils.toNiceTimeFormat(value*60)
            }
            else if(chartData.suffix == '%') { 
              if(chartInfo.label == 'Bot Automation Score' && (chartInfo.value == undefined || chartInfo.value == -1)){
                value = 'N/A'
              }else{
                value = `${value}%`;
              }
            }
            else {
              if((chartInfo.label == 'Bot Experience Score' || chartInfo.label == 'Agent Experience Score')
              && (chartInfo.value == undefined || chartInfo.value == -1)
              ){
                value = 'N/A'
              }else{
                value = WyUtils.formatterNumber(value);
              }
            }
            
            list.push({
              label: chartInfo.label,
              displayValue: value
            });
          }
        });
      }
      return list.reverse();
    },

    handleHandingTime() {
      this.chartDataA =  {id: 'chartA', title: 'Total Handle Time', columns: ['sumHandlingTime'], data: this.dataA, format: 'time', suffix: 'm'}
      this.chartDataB =  {id: 'chartB', title: 'Total Handle Time', columns: ['sumHandlingTime'], data: this.dataB, format: 'time', suffix: 'm'}
      this.changeDateRange(this.chartViewType);
    },
    handleTransfers() {
      this.chartDataA =  {id: 'chartA', title: 'Average Handoffs', columns: ['avgTransfers'], data: this.dataA, format: '0,0', suffix: ''}
      this.chartDataB =  {id: 'chartB', title: 'Average Handoffs', columns: ['avgTransfers'], data: this.dataB, format: '0,0', suffix: ''}
      this.changeDateRange(this.chartViewType);
    },
    handleResponseTime() {
      this.chartDataA =  {id: 'chartA', title: 'Agent Response Time', columns: ['sumResponseTime'], data: this.dataA, format: 'time', suffix: 'm'}
      this.chartDataB =  {id: 'chartB', title: 'Agent Response Time', columns: ['sumResponseTime'], data: this.dataB, format: 'time', suffix: 'm'}
      this.changeDateRange(this.chartViewType);
    },
    handleChatVolume() {
      this.chartDataA =  {id: 'chartA', title: 'Volume', columns: ['sumVolumeDMValue'], data: this.dataA, format: '0,0', suffix: ''}
      this.chartDataB =  {id: 'chartB', title: 'Volume', columns: ['sumVolumeDMValue'], data: this.dataB, format: '0,0', suffix: ''}
      this.changeDateRange(this.chartViewType);
    },
    handleContainment() {
      this.chartDataA =  {id: 'chartA', title: 'Containment Rate', columns: ['sumContainmentPercent'], data: this.dataA, format: ',f', suffix: '%'}
      this.chartDataB =  {id: 'chartB', title: 'Containment Rate', columns: ['sumContainmentPercent'], data: this.dataB, format: ',f', suffix: '%'}
      this.changeDateRange(this.chartViewType);
    },
    handleContainedConversations() {
      this.chartDataA =  {id: 'chartA', title: 'Contained Conversations Volume', columns: ['sumContainment'], data: this.dataA, format: '0,0', suffix: ''}
      this.chartDataB =  {id: 'chartB', title: 'Contained Conversations Volume', columns: ['sumContainment'], data: this.dataB, format: '0,0', suffix: ''}
      this.changeDateRange(this.chartViewType);
    },
    handleBas() {
      this.chartDataA =  {id: 'chartA', title: 'Bot Automation Score', columns: ['sumBasPercent'], data: this.dataA, format: ',f', suffix: '%'}
      this.chartDataB =  {id: 'chartB', title: 'Bot Automation Score', columns: ['sumBasPercent'], data: this.dataB, format: ',f', suffix: '%'}
      this.changeDateRange(this.chartViewType);
    },
    handleBes() {
      this.chartDataA =  {id: 'chartA', title: 'Bot Experience Score', columns: ['sumBesPercent'], data: this.dataA, format: ',f', suffix: ''}
      this.chartDataB =  {id: 'chartB', title: 'Bot Experience Score', columns: ['sumBesPercent'], data: this.dataB, format: ',f', suffix: ''}
      this.changeDateRange(this.chartViewType);
    },
    handleAes() {
      this.chartDataA =  {id: 'chartA', title: 'Agent Experience Score', columns: ['sumAvgAes'], data: this.dataA, format: ',f', suffix: ''}
      this.chartDataB =  {id: 'chartB', title: 'Agent Experience Score', columns: ['sumAvgAes'], data: this.dataB, format: ',f', suffix: ''}
      this.changeDateRange(this.chartViewType);
    },
    handleResolution() {
      this.chartDataA =  {id: 'chartA', title: 'Resolution', columns: ['sumResolved'], data: this.dataA, format: '0,0', suffix: '%'}
      this.chartDataB =  {id: 'chartB', title: 'Resolution', columns: ['sumResolved'], data: this.dataB, format: '0,0', suffix: '%'}
      this.changeDateRange(this.chartViewType);
    },
    handleSentiment() {
      this.chartDataA =  {id: 'chartA', title: 'Sentiment', columns: ['sumNegative', 'sumNeutral', 'sumPositive'], data: this.dataA, format: ',f', suffix: '%'}
      this.chartDataB =  {id: 'chartB', title: 'Sentiment', columns: ['sumNegative', 'sumNeutral', 'sumPositive'], data: this.dataB, format: ',f', suffix: '%'}
      this.changeDateRange(this.chartViewType);
    }
  },

  mounted() {
    this.handleChatVolume();
    this.changeDateRange();
  }
});
</script>

<style lang="scss">
.wy-analytics-compare-metrics-chart {
  min-height: 200px;
  box-shadow: 0px 1px 5px #0000001A;
  border-radius: 10px 10px 10px 10px;
  background-color: #fff;
  padding: 10px 20px 30px 20px;
  margin-bottom: 25px;
  
  table.tr {
    vertical-align: baseline !important;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    line-height: 0;
    margin-left: 25px;
    color: #002852;
  }

  .chartTitle {
    font-size: 15px;
    font-weight: 500;
    color: #002852;   
  }

  .chartDate {
    font-size: 12px;
    margin-bottom: 8px;
    color: #002852;
  }

  .chartTraceLabel {
    font-size: 14px;
    text-align: center;

    div.chartTraceRow {
      margin-bottom: 130px;
      margin-top: 50px;
    }

    div.chartTraceRow {
      margin-bottom: 100px;
      margin-top: 10px;
    }

    div.chartTraceRow:last-child {
      margin-bottom: 20px;
    }

    .chartTracePercent {
      font-weight: bold;
      font-size: 16px;
      line-height: 14px;
      color: #002852;
    }
  }
  td.td-comparison-a {
    vertical-align: baseline;
  }
  td.td-comparison-a.single {
    .chartDate {
      padding-top: 110px;
      margin-bottom: 10px;
    }
  }

  td.td-comparison-b {
    vertical-align: baseline;
  }
  td.td-comparison-b.single {
    .chartDate {
      padding-top: 110px;
      margin-bottom: 10px;
    }
  } 

  .el-select:hover .el-input__inner {
    border-color: var(--site-font-primary-color);
  }
  .el-input.is-focus .el-input__inner {
    border-color: var(--site-font-primary-color);
  }
  .el-select .el-input__inner:focus {
    border-color: var(--site-font-primary-color);
  }
  input.el-input__inner {
    border-width: 1px 1px 1px 1px !important;
    border-radius: 10px;
    padding-left: 13px;
    padding-top: 2px;
    border-color: var(--site-font-primary-color);
  }
  .el-select .el-input .el-select__caret {
    background-image: url('../../assets/icons/icon_dropdown_arrow_down.png');
    background-repeat: no-repeat;
    background-size: 8px 5px;
    background-position-x: 4px;
    background-position-y: 12px;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    transform: rotateZ(0);
    position: relative;
    left: 2px;
  }
  .el-icon-arrow-up:before {
    content: " ";
  }

  .no-chart-data {
    font-size: 15px;
    text-align: center;
    padding: 3px 10px 3px 10px;
    font-weight: 500;
    color: #636363;
  }
  .no-chart-data-icon {
    background-image: url('../../assets/icons/icon_no_data.svg');
    height: 90px;
    background-repeat: no-repeat;
    background-size: 90px;
    background-position: center;    
  }
}
.line-chart-dropdown {
  .el-select-dropdown__item.selected {
    color: var(--site-font-primary-color);
    font-weight: normal;
  }
  .el-scrollbar__wrap {
    display: block !important;
  }
}
</style>